var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9685 0.75H12.5C12.9142 0.75 13.25 1.08579 13.25 1.5C13.25 1.91421 12.9142 2.25 12.5 2.25H1.5C1.08579 2.25 0.75 1.91421 0.75 1.5C0.75 1.08579 1.08579 0.75 1.5 0.75H4.0315C4.14252 0.318693 4.53404 0 5 0H9C9.46596 0 9.85748 0.318693 9.9685 0.75ZM3.68296 4.5L4.83681 14.5H9.16306L10.3169 4.5H3.68296ZM3.12195 3H10.8779C11.4756 3 11.9398 3.52086 11.8713 4.11462L10.6021 15.1146C10.5439 15.6192 10.1166 16 9.60868 16H4.39118C3.88325 16 3.456 15.6192 3.39778 15.1146L2.12854 4.11462C2.06003 3.52086 2.52425 3 3.12195 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c197f57b.svg";
export { ForwardRef as ReactComponent };